import { ethers } from "ethers"
import { useContext } from 'react'
import { ConfigContext } from '@/utils/contextStatic'

/**
 * Ethers基础方法 - 版本6.6.7
 */
export default function usePublicEthers() {

  const { supportChainList, chainSign } = useContext(ConfigContext)

  // 输出格式转换
  const _outPutFormat = (num: number | string, decimal = 18) => {
    return ethers.formatUnits(num, decimal).toString()
  }

  // 输入格式转换
  const _inPutFormat = (num: string, decimal = 18) => {
    return ethers.parseUnits(num, decimal).toString()
  }

  /**
   * 集成ethers.js - 基于浏览器
   */
  const _getBrowserProvider = () => {
    const ethereum: any = window.ethereum
    return new ethers.BrowserProvider(ethereum)
  }

  /**
   * 集成ethers.js - 基于JSON-RPC
   * @param {String}  rpc              JSON-RPC
   */
  const _getJsonRpcProvider = (rpc: string) => {
    return new ethers.JsonRpcProvider(rpc)
  }

  /**
   * 对Provider进行签名
   * @param {String}  account          用户地址
   */
  const _getSigner = async (account?: string) => {
    const provider = await _getBrowserProvider()
    if (account) {
      return provider.getSigner(account)
    } else {
      return provider.getSigner()
    }
  }

  /**
   * 验证钱包地址
   * @param {String}  address        钱包地址
   */
  const _isAddress = (address: string) => {
    return ethers.isAddress(address)
  }

  /**
   * 获取 - GasPrice
   */
  const _getGasPrice= async() => {
    const chainInfo = supportChainList.find((item:any) => item['chain_id'] === chainSign)
    const rpcProvider = _getJsonRpcProvider(chainInfo['rpc_node'])
    const gasPrice:any = (await rpcProvider.getFeeData()).gasPrice?.toString()
    return _outPutFormat(gasPrice, 9)
  }

  /**
   * 校验是否是ERC20合约
   * @param {String}  addr              ERC20代币合约地址
   */
  const _checkerErc20Fun = async(addr:string) => {
    const isPass = _isAddress(addr)
    if(isPass) {
      const provider = await _getBrowserProvider()
      let code = await provider.getCode(addr)
      if(code != "0x"){
        // 检查bytecode中是否包含transfer函数和totalSupply函数的selector
        if(code.includes("a9059cbb") && code.includes("18160ddd")){
          return true
        }else{
          return false
        }
      } else{
        return null
      }
    } else {
      return null
    }
  }

  return {
    _getJsonRpcProvider,
    _getBrowserProvider,
    _checkerErc20Fun,
    _outPutFormat,
    _inPutFormat,
    _getGasPrice,
    _isAddress,
    _getSigner
  }
}
